export default __webpack_public_path__ + "static/media/xd.36a0778e.svg";